import { createRef } from "react";

import "./tablePlaceholder.scss";

export function TablePlaceholder({ columns, rows }) {
    const ref = createRef();
    const header = [];
    const body = [];

    for (let i = 0; i < columns; i++) {
        header.push(<div key={i} className="cell" />);
    }

    for (let i = 0; i < rows; i++) {
        body.push(<div key={i} className="cell" />);
    }

    return (
        <div className="placeholder-loader table-placeholder" ref={ref}>
            <div className="header">
                {header}
            </div>
            <div className="body">
                {body}
            </div>
        </div>
    );
}
